import { getUserName } from '../login/reducers'

const initState = {
    eclosVoucherCode: '100000572'
}

const vouchers = (state = initState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export const eclosVoucherCode = state => {
    return state.vouchers.eclosVoucherCode;
}

export const canSeeEclosVoucher = state => {
    if(!getUserName(state)){
        return false;
    }
    const eclosVoucherList = [
        '0000411889',
        '0000453345',
        '0000428225',
        '0000424188',
        '0000430481',
        '0000432043',
        '0000438148',
        '0000413464',
        '0000419121',
        '0000413469',
        '0000415267',
        '0000416957',
        '0000413119',
        '0000431649',
        '0000413012',
        '0000413120',
        '0000409129',
        '0000411291',
        '0000409836',
        '0000414458',
        '0000412473',
        '0000410513',
        '0000423115',
        '0000415967',
        '0000419301',
        '0000412508',
        '0000431304',
        '0000422830',
        '0000420106',
        '0000409281',
        '0000411828',
        '0000408817',
        '0000424456',
        '0000413404',
        '0000418300',
        '0000418479',
        '0000418500',
        '0000418502',
        '0000419127',
        '0000419787',
        '0000433174',
        '0000409623',
        '0000415652',
        '0000410219',
        '0000411055',
        '0000417682',
        '0000409997',
        '0000421573',
        '0000440076',
        '0000409061',
        '0000409567',
        '0000410291',
        '0000411506',
        '0000410434',
        '0000410844',
        '0000417548',
        '0000430331',
        '0000413067',
        '0000410530',
        '0000412469',
        '0000414597',
        '0000411214',
        '0000411670',
        '0000412944',
        '0000435106',
        '0000408992',
        '0000437557',
        '0000412472',
        '0000408913',
        '0000409522',
        '0000409953'
    ]

    if (eclosVoucherList.includes(getUserName(state).padStart(10, '0'))) return true

    return false
}

export default vouchers